import { render } from "./StreamlinedHome.vue?vue&type=template&id=e649d9fe&scoped=true"
import script from "./StreamlinedHome.vue?vue&type=script&lang=ts"
export * from "./StreamlinedHome.vue?vue&type=script&lang=ts"

import "./StreamlinedHome.vue?vue&type=style&index=0&id=e649d9fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e649d9fe"

export default script